<template>
  <div v-if="product" class="product-attributes">
    <div v-if="typeVariation == 'button'">
      <div
        v-for="(option, index) in product.options"
        class="product-form__item"
        :key="option.id"
      >
        <label
          class="product-form__item_label"
          :for="`product-option-${option.id}`"
        >
          {{ option.name }}:
          <span class="product-form__item_active">
            {{ attributes[`option${index + 1}`] }}
          </span>
        </label>
        <div class="group-option">
          <div
            class="group-option-group-item"
            v-for="value in getOptions(index + 1)"
          >
            <input
              style="display: none;"
              :id="`product-itemoption-${option.id}-${value}`"
              :name="`product-itemoption-${option.id}`"
              type="radio"
              :value="value"
              v-model="attributes[`option${index + 1}`]"
            />
            <label
              class="group-option-item"
              :class="{
                active: attributes[`option${index + 1}`] == value
              }"
              :for="`product-itemoption-${option.id}-${value}`"
            >
              <div class="control-item-variation">
                <img
                  class="control-item-variation-image"
                  :src="imageArrayVariation[value]"
                  v-if="imageArrayVariation[value]"
                />
                <div class="control-item-variation-label">{{ value }}</div>
              </div>
            </label>
          </div>
        </div>

        <div
          class="framd-color-contaner"
          :class="{
            show: attributes[`option${index + 1}`] == 'Framed Canvas',
            hide: attributes[`option${index + 1}`] != 'Framed Canvas'
          }"
        >
          <label
            class="product-form__item_label"
            :for="`product-option-${option.id}`"
          >
            Framed Color:
            <span class="product-form__item_active">{{ framedColor }}</span>
          </label>
          <div class="group-framed-color">
            <div class="group-framed-color-item" v-for="framed in framedColors">
              <input
                v-if="attributes[`option${index + 1}`] == 'Framed Canvas'"
                style="display: none;"
                :id="`product-item-framed-${framed.value}`"
                name="properties[Framed Color]"
                type="radio"
                :value="framed.value"
                v-model="framedColor"
                :form="`product_form_${product.id}`"
              />
              <label
                class="group-option-item-framed"
                :class="{
                  active: framedColor == framed.value
                }"
                :for="`product-item-framed-${framed.value}`"
              >
                <div class="control-item-framed-variation">
                  <img
                    class="control-item-framed-image"
                    :src="framed.img"
                    v-if="framed.img"
                  />
                  <div class="control-item-framed-variation-label">
                    {{ framed.value }}
                  </div>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      v-for="(option, index) in product.options"
      class="product-form__item"
      :key="option.id"
    >
      <label :for="`product-option-${option.id}`">{{ option.name }}</label>
      <select
        :id="`product-option-${option.id}`"
        class="form-select"
        v-model="attributes[`option${index + 1}`]"
      >
        <option
          v-for="value in getOptions(index + 1)"
          :key="value"
          :value="value"
        >
          {{ value }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import { forEach, get, pick, union } from 'lodash'
import jQuery from 'jquery'
export default {
  data() {
    return {
      selectedVariant: null,
      attributes: { option1: null, option2: null, option3: null },
      typeVariation: 'button',
      imageArrayVariation: {
        'Wrapped Canvas':
          'https://d2xkqnccwhm2wc.cloudfront.net/images/5ibL46po2zeTYuyTtVWe9cZRpZaJWPY73RcBOMAO.webp',
        'Framed Canvas':
          'https://d2xkqnccwhm2wc.cloudfront.net/images/BpshNqqNzeuOA02SsOD256No5TI22MEW9AOxtqwh.webp'
      },
      framedColor: 'Black',
      framedColors: [
        {
          value: 'Black',
          img:
            'https://cdn.shopify.com/s/files/1/0981/9134/3938/files/blackf3_optimized.png?v=1767944421'
        },
        {
          value: 'Brown',
          img:
            'https://cdn.shopify.com/s/files/1/0981/9134/3938/files/brownf3_optimized.png?v=1767944421'
        },
        {
          value: 'Natural',
          img:
            'https://cdn.shopify.com/s/files/1/0981/9134/3938/files/naturalf3_optimized.png?v=1767944421'
        },
        {
          value: 'White',
          img:
            'https://cdn.shopify.com/s/files/1/0981/9134/3938/files/whitef3_optimized.png?v=1767944421'
        }
      ]
    }
  },
  mounted() {
    var selectedVariantId = jQuery('[name=id]').val()
    if (selectedVariantId) {
      const { variants } = this
      var variant = variants.find(
        v => v.id.toString() === selectedVariantId.toString()
      )
      this.selectedVariant = variant
      this.attributes = pick(variant, ['option1', 'option2', 'option3'])
    }
  },
  watch: {
    selectedVariant(variant) {
      this.setSelectedVariant(variant)
    },
    attributes: {
      handler(attributes) {
        const { variants } = this
        this.selectedVariant = variants.find(v => {
          var match = true
          forEach(attributes, (value, key) => {
            if (v[key] !== value) {
              match = false
            }
          })
          return match
        })
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(['product']),
    variants() {
      const { product } = this
      return get(product, 'variants', [])
    }
  },
  methods: {
    ...mapMutations(['setSelectedVariant']),

    setSelectedVariant(variant) {
      if (variant) {
        this.setSelectedVariant(variant.id)
        var variantEl = jQuery('[name=id]')
        if (variantEl.length === 0) {
          variantEl = jQuery('<input type="hidden" name="id"/>')
          jQuery(`form[action^='/cart/add']`).append(variantEl)
        }
        variantEl.val(variant.id)
        window.history.pushState(
          {},
          '',
          `${window.location.pathname}?variant=${variant.id}`
        )
        var money_format = window.money_format || '${{amount}}'
        jQuery('.price-item--sale').text(
          money_format.replace(/{{.*}}/, variant.price)
        )
        if (variant.compare_at_price) {
          jQuery('.price-item--regular').text(
            money_format.replace(/{{.*}}/, variant.compare_at_price)
          )
        } else {
          jQuery('.price-item--regular').text(
            money_format.replace(/{{.*}}/, variant.price)
          )
        }
      }
    },
    getOptions(index) {
      const { variants, attributes } = this
      var filter = {}
      for (let i = index - 1; i > 0; i--) {
        var key = `option${i}`
        filter[key] = this.attributes[key]
      }
      var _options = union(
        variants
          .filter(v => {
            var match = true
            forEach(filter, (value, key) => {
              if (v[key] !== value) {
                match = false
              }
            })
            return match
          })
          .map(v => v[`option${index}`])
      )
      if (!_options.includes(attributes[`option${index}`])) {
        this.attributes = { ...attributes, [`option${index}`]: _options[0] }
      }
      return _options
    }
  }
}
</script>

<style>
.group-option-group-item {
  width: 180px;
  max-width: 48%;
  margin: 3px 3px !important;
  cursor: pointer !important;
}
.group-option-item {
  display: flex;
  justify-content: center;
  width: 100%;
  border: 1px solid #a5a5a5;
  padding: 8px 10px;
  cursor: pointer !important;
  border-radius: 3px;
  text-align: center;
}
.group-option-item * {
  color: #000;
}
.control-item-variation-image {
  cursor: pointer !important;
}
.control-item-variation {
  cursor: pointer !important;
}
.group-option-item.active {
  background: #edc45c;
  border: 1px solid #edc45c;
}
.group-option-item.active * {
  color: #fff;
}
.group-option {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
}

.control-item-variation-image {
  width: 90px;
}
.product-form__item {
  margin-bottom: 10px;
}
.product-form__item:last-child {
  margin-bottom: 0px;
}
.product-form__item_label {
  font-size: 16px;
  font-weight: 600;
}
.product-form__item_active {
  color: rgb(48, 145, 40);
  font-weight: 500;
  font-size: 15px;
}
.group-framed-color {
  display: flex;
}
.control-item-framed-image {
  width: 100%;
}
.group-framed-color-item {
  width: 82px;
  max-width: 48%;
  margin: 3px 3px !important;
}
.group-option-item-framed {
  display: flex;
  justify-content: center;
  border: 1px solid #a5a5a5;
  cursor: pointer !important;
  width: 100%;
  padding: 8px 10px;
  border-radius: 3px;
  text-align: center;
}
.group-option-item-framed * {
  cursor: pointer !important;
}
.group-option-item-framed.active {
  background: #edc45c;
  border: 1px solid #edc45c;
}
.group-option-item-framed.active * {
  color: #fff;
}
.framd-color-contaner {
  margin-top: 10px;
}
.framd-color-contaner.show {
  display: block;
}
.framd-color-contaner.show .group-framed-color {
  opacity: 0;
  transform: translateY(-20px);
  animation: slideDownFade 0.5s ease-out forwards;
}
.framd-color-contaner.hide {
}
.framd-color-contaner.hide {
  opacity: 1;
  transform: translateY(0);
  animation: slideUpFade 0.2s ease-out forwards;
}
@keyframes slideDownFade {
  0% {
    opacity: 0;
    transform: translateY(-20px); /* Bắt đầu từ phía trên */
  }
  100% {
    opacity: 1;
    transform: translateY(0); /* Về vị trí gốc */
  }
}

@keyframes slideUpFade {
  0% {
    opacity: 1;
    transform: translateY(0); /* Bắt đầu từ phía trên */
  }
  100% {
    opacity: 0;
    transform: translateY(-20px); /* Về vị trí gốc */
    display: none;
  }
}
.control-item-framed-variation-label {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Form/Attributes.vue